module.exports = __webpack_public_path__ + "static/media/unispacelifesciences.5a42daf6.png";